import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { ApiResponse } from './bonus-codes.entity';

@Injectable({
  providedIn: 'root'
})
export class BonusCodesService extends AbstractService {
  protected override prefix = '/bonuses/codes';

  useBonusCode(code: string): Observable<ApiResponse.BonusCodeUsed> {
    return this.post<ApiResponse.BonusCodeUsed>('/use', { code }, { throwError: true });
  }
}